/**
 * deepseek -- 输入
 */
import React, { useEffect, useRef } from 'react'
import { Button, Input, message, Modal } from 'antd'
import styles from './index.module.css'
import {
  Plus,
  IconFasong,
  IconTingzhi,
  IconXiayihua,
  MirrorLoading,
} from 'wujieai-react-icon'
import classNames from 'classnames'
import { useState } from 'react'
import { useAuth } from '~/hooks/useAuth'
import {
  useIsMessageListReachBottom,
  useScrollMessageListToBottom,
} from '~/components/pages/deepseek/hooks'
import { useAtomValue } from 'jotai'
import { conversationIdAtom } from '~/components/pages/deepseek/atom'
import { useValidateVip } from '~/hooks/useValidateVip'
import type { InputRef } from 'antd'
import FileUpload from './FileUpload'
import FileList from './FileList'
import { graphQLErrorMessage } from '~/utils'
interface IProps {
  sendMessage: (params: any) => Promise<void>
  isTyping: boolean
  stopMessage: () => void
  className?: string
  style?: React.CSSProperties
}

const GPT4oInput: React.FC<IProps> = ({
  sendMessage,
  stopMessage,
  isTyping,
  className,
  style,
}) => {
  const [fileList, setFileList] = useState<any[]>([])
  const [prompt, setPrompt] = useState('')
  const { reachBottom: isMessageListReachBottom } =
    useIsMessageListReachBottom()
  const scrollMessageListToBottom = useScrollMessageListToBottom()
  const conversationId = useAtomValue(conversationIdAtom)
  const inputRef = useRef<InputRef>(null)

  const { isHighUser } = useAuth()
  const { vipModal } = useValidateVip()

  const seeking = isTyping

  const [isLoading, setIsLoading] = useState(false)
  /** 发送 */
  const onSend = async () => {
    if (!prompt) {
      return
    }
    if (!isHighUser) {
      vipModal('此功能仅限VIP会员用户使用')
      return
    }
    if (fileList.some(it => it.url === undefined)) {
      message.destroy()
      message.warn('请等待所有图片上传完成')
      return
    }

    try {
      setIsLoading(true)
      await sendMessage({
        input: prompt,
        referImages: fileList.map(it => it.url),
      })
      // 清空输入框
      setPrompt('')
      setFileList([])
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '未知错误')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setPrompt('')
    // setFileList([])
    inputRef?.current!.focus({
      cursor: 'end',
    })
  }, [conversationId])

  const OpButton = () => {
    if (seeking) {
      return (
        <Button
          type="primary"
          shape="circle"
          className="!h-8 !w-8 !p-0 !flex justify-center items-center !border-0"
          onClick={stopMessage}
        >
          <IconTingzhi size={24} />
        </Button>
      )
    }

    if (isLoading) {
      return (
        <Button
          type="ghost"
          shape="circle"
          className={classNames(
            '!h-8 !w-8 !p-0 !flex items-center justify-center  !border-0 !bg-neutral-300 !text-neutral-400 cursor-default'
          )}
          onClick={onSend}
        >
          <MirrorLoading size={20} className="block animate-spin" />
        </Button>
      )
    }

    return (
      <Button
        type="primary"
        shape="circle"
        className={classNames(
          '!h-8 !w-8 !p-0 !flex items-center justify-center  !border-0',
          !prompt && '!bg-neutral-300 !text-neutral-400'
        )}
        onClick={onSend}
      >
        <IconFasong size={24} className="block" />
      </Button>
    )
  }

  return (
    <div className={classNames(className, styles.footerWrap)} style={style}>
      {!isMessageListReachBottom && (
        <div
          onClick={() => scrollMessageListToBottom()}
          className="absolute -top-[50px] right-4 z-10 w-8 h-8 rounded-full bg-neutral-300 flex items-center justify-center p-2 cursor-pointer"
        >
          <IconXiayihua className="text-neutral-500" />
        </div>
      )}

      {!!fileList.length && (
        <FileList list={fileList} setFileList={setFileList} />
      )}

      <Input.TextArea
        ref={inputRef}
        placeholder="请向我描述画面内容~"
        className={classNames(styles.input)}
        value={prompt}
        onChange={e => {
          setPrompt(e.target.value)
        }}
        onPressEnter={e => {
          if (!e.shiftKey && !seeking) {
            e.preventDefault()
            onSend()
          }
        }}
        rows={1}
        maxLength={4000}
        autoSize={{ maxRows: 3 }}
      />
      <div className="flex justify-between items-center pt-6">
        <div className="flex text-xs font-bold text-neutral-400"></div>
        <div className="flex items-center gap-3">
          <FileUpload
            className={classNames(
              'overflow-hidden',
              styles.btn,
              fileList.length >= 10
                ? '!bg-neutral-300 !text-neutral-200'
                : '!bg-neutral-300 text-neutral-400'
            )}
            disabled={fileList.length >= 10}
            multiple
            accept="image/*"
            setFileList={setFileList}
            maxCount={10}
          >
            <Plus size={24} />
          </FileUpload>
          <OpButton />
        </div>
      </div>
    </div>
  )
}
export default GPT4oInput
